import config from '../config';

import { isProduction } from './utils';

export const catfoodUrl = () => config.launchdarkly.baseUrl || 'https://app.ld.catamorphic.com';

export const catfoodProject = () => config.launchdarkly.project || 'default';

export const linkToCatfood = (accountID: string) =>
  `${catfoodUrl()}/${catfoodProject()}/${config.launchdarkly.environment}/contexts/account/${accountID}`;

export const linkToHowToGhostConfluencePage = () =>
  'https://launchdarkly.atlassian.net/wiki/spaces/ENG/pages/226657888/How+to+ghost';

export const linkToSessionReplay = (accountID?: string, memberID?: string) => {
  const baseURL = 'https://app.ld.catamorphic.com/projects/default/sessions';

  // Only include account filter if accountID exists
  const queryParts: string[] = [];
  if (accountID) {
    queryParts.push(`account%3D%22*${accountID}*%22`);
  }

  // Include member filter if memberID exists
  if (memberID) {
    queryParts.push(`member%3D%22*${memberID}*%22`);
  }

  const queryString = queryParts.join('+');
  return `${baseURL}?query=${queryString}&page=1&relativeTime=last_30_days&env=staging&env=production&selected-env=production`;
};

export const honeycombDataset = () => config.honeycomb.dataset;

export const linkToHoneycombEvents = (accountID: string) => {
  const dataset = honeycombDataset();
  return `https://ui.honeycomb.io/launchdarkly/datasets/${dataset}?query={"breakdowns":["environment"],"calculations":[{"op":"COUNT"},{"column":"all_event_len","op":"SUM"}],"filters":[{"column":"service_name","op":"=","value":"event-recorder"},{"column":"name","op":"=","value":"eventPool"},{"column":"account","op":"=","value":"${accountID}"}],"orders":[{"op":"COUNT","order":"descending"}],"limit":100,"time_range":7200}`;
};

export const linkToHoneycombSDKVersions = (accountID: string) => {
  const dataset = honeycombDataset();
  return `https://ui.honeycomb.io/launchdarkly/datasets/${dataset}?query={"breakdowns":["environment","user_agent"],"calculations":[{"op":"COUNT"}],"filters":[{"column":"account","op":"=","value":"${accountID}"}],"orders":[{"op":"COUNT","order":"descending"}],"limit":100,"time_range":7200}`;
};

export const linkToSalesforce = (accountID: string) => {
  const payload = JSON.stringify({
    componentDef: 'forceSearch:searchPageDesktop',
    attributes: {
      term: accountID,
      scopeMap: { type: 'TOP_RESULTS' },
      groupId: 'DEFAULT',
    },
    state: {},
  });
  return `https://launchdarkly.lightning.force.com/one/one.app#${btoa(payload)}`;
};

export const linkToStripe = (accountID: string) => {
  const baseUrl = isProduction() ? 'https://dashboard.stripe.com' : 'https://dashboard.stripe.com/test';
  return `${baseUrl}/search?query=is%3Acustomer%20${accountID}`;
};

export const linkToLooker = (accountID: string) =>
  `https://launchdarkly.cloud.looker.com/dashboards/14?Type=Customer&SFDC+Account+Key=&Date+Granularity=&Timeframe=6+month&LD+Account+ID=${accountID}`;

export const linkToHex = (accountID: string) =>
  `https://app.hex.tech/a31d3be0-7430-4ff6-80a9-aeef5a2acdaf/app/Account-Overview-Drill-down-033jkMDeAvOrLUQp5nyKCP/latest?_ld_account_id=%22${accountID}%22`;

export const linkToDataDogLogs = (accountID: string) => {
  const federal =
    process.env.VITALSTATISTIX_MODE === 'federal' || process.env.VITALSTATISTIX_MODE === 'federal-staging';
  return federal
    ? `https://launchdarkly.ddog-gov.com/logs?query=${accountID}`
    : `https://app.datadoghq.com/logs?query=${accountID}`;
};

export const linkToOrb = (orbSubscriptionId: string) => {
  if (isProduction()) {
    return `https://app.withorb.com/subscriptions/${orbSubscriptionId}`;
  }
  // For non-production, return the subscription ID so we can handle it with JavaScript
  return orbSubscriptionId;
};
